<p>my-rewards works!</p>
